import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {Solicitar} from './Solicitar';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {SuperiroCategoriasEmpresa} from './SuperiroCategoriasEmpresa';
import {CatServActivos} from './CatServActivos';
import {CatServPendientes} from './CatServPendientes';
import {CatServAñadir} from './CatServAñadir';
import {CatServInactivos} from './CatServInactivos';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {useNavigate} from 'react-router-dom';

export const ContentBodyCategoriaEmpresa = (props) => {
	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const {MenuLateralAux, chageMenuLateralAux} = props;
	const [TipoNotificaciones, setTipoNotificaciones] = useState([
		'buttonNotificacionesActive',
		'buttonNotificaciones',
		'buttonNotificaciones',
		'buttonNotificaciones',
	]);

	const [Servicios, setServicios] = useState([]);
	const [Categorias, setCategorias] = useState([]);

	const [ServiciosPendientes, setServiciosPendientes] = useState([]);
	const [CategoriasPendientes, setCategoriasPendientes] = useState([]);

	const [ServiciosInactivo, setServiciosInactivo] = useState([]);
	const [activar, setActivar] = useState(false);
	const [servicio, setServicio] = useState();
	const [modalActivarDesactivar, setModalActivarDesactivar] = useState(false);

	const [sedes, setSedes] = useState();
	const [sedeId, setSedeId] = useState([]);

	const [serviciosSedes, setServiciosSedes] = useState([]);

	const [empresa, setEmpresa] = useState({
		idEmpresa: '-------',
		nombreEmpresa: 'nombreEmpresSa',
		nombreContactoEmpresa: 'nombreContactoEmpresa',
		apellidosContactoEmpresa: 'apellidosContactoEmpresa',
		constraseña: 'constraseña',
		repitaConstraseña: 'repitaConstraseña',
		telefono: '666666666',
		direccion: 'direccion',
		codigoPostal: 'codigoPostal',
		webEmpresa: 'webEmpresa',
		emailEmpresa: 'emailEmpresa',
		tamañoEmpresa: '0',
		shareCare: false,
		descripcionEmpresa: 'descripcionEmpresa',
		notasEmpresa: 'notasEmpresa',
	});

	const navigate = useNavigate();

	const getDatEmpresa = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'prestadorServicios/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			// Introduciomos los datos del presatador de servicios al usuario
			setEmpresa(response.data[0]);
		});
	};

	const get_sedes = () => {
		if (empresa)
        console.log('Empresa Id',empresa.id)
			axios({
				method: 'get',
				url: window.ipdirection + 'sedePrestador/?idempresa=' + empresa.id,
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
			}).then((response) => {
				setSedes(response.data);
			});
	};

	/* A function that is called when the user clicks on one of 
  the buttons on the top of the page. */
	const cambioNotificaciones = (num) => {
		//setServicioPacientes([])
		let listaAxu = [
			'buttonNotificaciones',
			'buttonNotificaciones',
			'buttonNotificaciones',
			'buttonNotificaciones',
		];
		listaAxu[num] = 'buttonNotificacionesActive';
		switch (num) {
			case 0:
				get_Servicio_Empresa_Activo();
				get_Categoria_Empresa_Activo();
				break;
			case 1:
				get_Servicio_Empresa_Inactivo();
				break;
			case 1:
				get_Servicio_Empresa_Pendiente();
				get_Categoria_Empresa_Activo();
				get_Categoria_Empresa_Pendiente();
				break;
			default:
				get_Servicio_Empresa_Activo();
				get_Categoria_Empresa_Activo();
				break;
		}
		/* A function that is called when the user clicks 
        on one of the buttons on the top of the page. */
		setTipoNotificaciones(listaAxu);
		//const tipes = ["get_Presupuestos_Hoy", "get_Presupuestos_Pendientes", "get_Presupuestos_Por_Confirmar", "get_Presupuestos_All",]
		//getPresupuestos(tipes[num]);
	};
	const get_Servicio_Empresa_Activo = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Servicio_Empresa_Activo/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setServicios([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const get_Categoria_Empresa_Activo = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Categoria_Empresa_Activo/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setCategorias([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const get_Servicio_Empresa_Pendiente = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Servicio_Empresa_Pendiente/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setServiciosPendientes([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const get_Categoria_Empresa_Pendiente = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Categoria_Empresa_Pendiente/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				let lista = [];
				lista.push(...Categorias);
				lista.push(...response.data);
				setCategoriasPendientes([...lista]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const get_Servicio_Empresa_Inactivo = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Servicio_Empresa_Inactivo/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setServiciosInactivo([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	useEffect(() => {
		getDatEmpresa();
		get_Categoria_Empresa_Activo();
		get_Servicio_Empresa_Activo();
		get_Servicio_Empresa_Inactivo();
	}, []);

    useEffect(() => {
        get_sedes()
    },[empresa])

	const activarDesactivarServicios = async () => {
		if (activar) {
			let data = {
				estado: 'activo',
				servicio_id: servicio,
				sede_id: sedeId,
			};
			axios({
				method: 'put',
				url: window.ipdirection + 'Servicio_Empresa_SedePrestador_Estado/' + servicio + '/',
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
				data: data,
			})
				.then((response) => {
					setModalActivarDesactivar(false);
					get_Servicio_Empresa_Inactivo();
					setServiciosSedes('');
				})
				.catch((error) => {
					console.log(error);
				});
		} else {
			let data = {
				estado: 'inactivo',
				servicio_id: servicio,
				sede_id: sedeId,
			};
			axios({
				method: 'put',
				url: window.ipdirection + 'Servicio_Empresa_SedePrestador_Estado/' + servicio + '/',
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
				data: data,
			})
				.then((response) => {
					setModalActivarDesactivar(false);
					get_Servicio_Empresa_Activo();
					setServiciosSedes('');
				})
				.catch((error) => {
					console.log(error);
				});
		}
	};

	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */

	return (
		<>
			<MenuLateralAB
				seleccionado={4}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='derContentPresupuestos'>
				<SuperiroCategoriasEmpresa
					TipoNotificaciones={TipoNotificaciones}
					cambioNotificaciones={cambioNotificaciones}
				/>
				{TipoNotificaciones[0] === 'buttonNotificacionesActive' ? (
					<CatServActivos
						Categorias={Categorias}
						Servicios={Servicios}
						setActivar={setActivar}
						setServicio={setServicio}
						setModalActivarDesactivar={setModalActivarDesactivar}
						Usuario={Usuario}
						sedeId={sedeId}
						setSedeId={setSedeId}
						sedes={sedes}
						get_sedes={get_sedes}
						setServiciosSedes={setServiciosSedes}
						serviciosSedes={serviciosSedes}
					/>
				) : TipoNotificaciones[1] === 'buttonNotificacionesActive' ? (
					<CatServInactivos
						Usuario={Usuario}
						Categorias={Categorias}
						ServiciosInactivo={ServiciosInactivo}
						setActivar={setActivar}
						sedes={sedes}
						setServicio={setServicio}
						setModalActivarDesactivar={setModalActivarDesactivar}
						sedeId={sedeId}
						setServiciosSedes={setServiciosSedes}
						serviciosSedes={serviciosSedes}
					/>
				) : TipoNotificaciones[2] === 'buttonNotificacionesActive' ? (
					<CatServPendientes
						CategoriasPendientes={CategoriasPendientes}
						ServiciosPendientes={ServiciosPendientes}
						Categorias={Categorias}
					/>
				) : (
					TipoNotificaciones[3] === 'buttonNotificacionesActive' && (
						<CatServAñadir sedes={sedes} />
					)
				)}
			</div>
			<Modal
				centered={true}
				isOpen={modalActivarDesactivar}
			>
				<ModalHeader>
					<div className='titulo-modal'>
						{activar ? '¿Desea activar el servicio?' : '¿Desea desactivar el servicio?'}
					</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						{activar
							? 'Este servicio aparecerá en su lista de servicios activos'
							: 'Este servicio aparecerá en su lista de servicios inactivos'}
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='button borrarCuenta'
							onClick={() => setModalActivarDesactivar(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => activarDesactivarServicios()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};

// <Solicitar />
